import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Api_Url } from "../../config/config";
import axios from "axios";
import { Button, Divider, Modal, Table } from "antd";
import { ErrorToast, SuccessToast, UpdatedToast } from "../../views/ToastComponent";
import "./ModalCustom.css"

function TeaStallProfileDetails() {
  const { id } = useParams();

  const [singleData, setSingleData] = useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [rawMaterial, setRawMaterial] = useState([]);
  const [selectedRawMaterial, setSelectedRawMaterial] = useState(null);

  const getSingleUser = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/TeaStall/material/getbyteastallid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setSingleData(response.data.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    getSingleUser();
  }, []);

  const [teaStallData, setTeaStallData] = useState({
    teaStallId: id,
    rawMaterialId: 0,
    quantity: 0,
    price: 0,
    totalAmount: 0,
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setTeaStallData((prevData) => ({
          ...prevData,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/TeaStall/material`,
        teaStallData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        SuccessToast("Added Successfully");
        handleCancel();
        getSingleUser();
      }
    } catch (error) {
      ErrorToast("Something Went wrong")
      return error.message;
    }
  };

  const calculateMonthlyRevenue = () => {
    // const consumption = selectedRawMaterial?.consumption || 0;
    const result = teaStallData.price * teaStallData.quantity ||0;
    setTeaStallData((prev) => ({
      ...prev,
      totalAmount: result,
    }));
  };

  useEffect(() => {
    calculateMonthlyRevenue();
  }, [teaStallData.price, teaStallData.quantity]);

  const handleClick = async (id) => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/TeaStall/material/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setTeaStallData(response.data.data);
      setIsEditModalOpen(true);
    } catch (error) {
      return error.message;
    }
  };

  const handleUpdate = async (id) => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/TeaStall/material/${id}`,
        teaStallData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        UpdatedToast("Successfully Updated");
        handleCancel();
        getSingleUser();
      }
    } catch (error) {
      ErrorToast("Something Went wrong")
      return error;
    }
  };

  const columns = [
    {
      title: "Raw Material",
      dataIndex: "rawMateriaName",
    },
    {
      title: "Price Per Unit",
      dataIndex: "price",
    },
    {
      title: "Consumption",
      dataIndex: "quantity",
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
    },
    {
      title: "Edit",
      dataIndex: "edit",
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
  ];

  const handleCancel = () => {
    setTeaStallData({
      ...teaStallData,
      teaStallId: id,
      rawMaterialId: 0,
      quantity: 0,
      price: 0,
      totalAmount: 0,
    });
    setIsEditModalOpen(false);
    setIsModalOpen(false);
  };

  const fetchRawMaterials = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/RawMaterial/getrawmaterialbyprofileid/17`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setRawMaterial(response.data.data);
    } catch (error) {
      console.error("Error fetching raw materials:", error.message);
    }
  };

  useEffect(() => {
    fetchRawMaterials();
  }, []);

  const handleRawMaterialChange = (rawMaterialId) => {
    const selectedMaterial = rawMaterial.find(
      (material) => material.id == rawMaterialId
    );
    setSelectedRawMaterial(selectedMaterial);
    setTeaStallData((prevData) => ({
      ...prevData,
      rawMaterialId,
      quantity: selectedMaterial ? selectedMaterial.consumption : 0,
    }));
  };


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mb-0">Tea Stall Assessment</h3>
              <button
                className="btn btn-primary submit-btn mb-2"
                onClick={() => setIsModalOpen(true)}
              >
                Exp. per cup
              </button>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12 mx-auto">
              <Table
                className="table-striped"
                style={{ overflowX: "auto" }}
                columns={columns}
                dataSource={singleData}
                rowKey={(record) => record.id}
              />
            </div>
          </div>
        </div>
      </div>

      <Modal
        title={<h4>Tea Stall</h4>}
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button
              key="Cancel"
              className="btn btn-danger submit-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            ,
            <button
              key="submit"
              className="btn btn-primary submit-btn"
              type="submit"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>,
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        className="custom-modal"
        closeIcon={<span style={{ color: 'red' }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <Divider>Add Tea Stall</Divider>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Raw Material Name:</label>
                  <select
                    className="form-control"
                    value={teaStallData.rawMaterialId}
                    onChange={(e) => handleRawMaterialChange(e.target.value)}
                  >
                    <option value="">Select Raw Material</option>
                    {rawMaterial.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Material Price (Per Kg/ltr/pcs):
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Material Price (Per Kg/ltr/pcs):"
                    value={teaStallData.price}
                    onChange={(e) =>
                      setTeaStallData({
                        ...teaStallData,
                        price: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Consumption Per Cup: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  {teaStallData.quantity.toFixed(5)}
                </span>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Expense on per cup: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  &#8377; {teaStallData.totalAmount.toFixed(3)}
                </span>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      {/* Edit modal */}

      <Modal
        title={<h4>Edit Tea Stall</h4>}
        open={isEditModalOpen}
        onOk={() => setIsEditModalOpen(false)}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button
              key="Cancel"
              className="btn btn-danger submit-btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            ,
            <button
              key="submit"
              className="btn btn-primary submit-btn"
              type="submit"
              onClick={() => handleUpdate(teaStallData.id)}
            >
              Submit
            </button>
          </div>,
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: 'red' }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <Divider>Edit Tea Stall</Divider>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">Raw Material Name:</label>
                  <select
                    className="form-control"
                    value={teaStallData.rawMaterialId}
                    onChange={(e) => handleRawMaterialChange(e.target.value)}
                  >
                    <option value="">Select Raw Material</option>
                    {rawMaterial.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Material Price (Per Kg/ltr/pcs):
                  </label>
                  <input
                    className="form-control"
                    type="number"
                    placeholder="Material Price (Per Kg/ltr/pcs):"
                    value={teaStallData.price}
                    onChange={(e) =>
                      setTeaStallData({
                        ...teaStallData,
                        price: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Consumption Per Cup: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  {teaStallData.quantity.toFixed(5)}
                </span>
              </div>
            </div>

            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Expense on per cup: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                  &#8377; {teaStallData.totalAmount.toFixed(3)}
                </span>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
}

export default TeaStallProfileDetails;
